/*!
 * (c) 2023 FlowCAD Poland
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'

/* //config for bootstrap-vue components:
BootstrapVue.setConfig({
  breakpoints: [`xs`, 'sm', 'md', 'lg', 'xl', 'xxl'],
  BAlert: { variant: 'danger' },
  BButton: { variant: 'secondary' }
})
*/

//import 'bootstrap/dist/css/bootstrap.css'
import './scss/_custom.scss';
//import 'bootstrap/scss/bootstrap.scss';
//import 'bootstrap-vue/dist/bootstrap-vue.css'
//import 'bootstrap-vue/src/index.scss';

//import * as Tools from './Tools/Tools'
import * as svgicons from './Tools/svgicons'
//import * as svgViewer from './Tools/svgViewer'


//console.log(svgViewer.CadfmSymbolViewer._currentPackage)

//import vSelect from 'vue-select'
//Vue.component('v-select', vSelect)
//import 'vue-select/dist/vue-select.css';
//import 'datatables.net-select-bs4/dist/css/datatables.net-select-bs4.css'
//import $ from 'jquery';
//console.log(store)

//localStorage.setItem('token', "qwert");
//console.log(Tools.getColorChartArray(5, "RGB", 0.7))
//var tempColor = Tools.getColorChartArray(5, "RGB", 0.7);
//console.log(tempColor)

//var client;

Vue.use(BootstrapVue);

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  methods:{

  },
  created(){

    this.$store.dispatch('setAlert', {type:"main.js", message:"Initialization", user: "not set yet"});

  },
  mounted: function () {



  }
})



// WEBPACK FOOTER //
// ./src/main.js